import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/medograf-casebg@2x-min.jpg';

export default {
  path: '/cases/medograf',
  color: variables.medograf,
  casebg,
  title: 'Medograf',
  headline: 'iOS application',
  description: 'Sharing the knowledge and experience of living with a mental disorder',
  isWeb: false,
  isAndroid: false,
};
